import { useRef } from "react";
import { LayoutContext } from "../contexts";

export const LayoutProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const mainContentRef = useRef<HTMLDivElement>(null);

  return (
    <LayoutContext.Provider value={{ mainContentRef }}>
      {children}
    </LayoutContext.Provider>
  );
};
